import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { H1 } from './H1';

const Wrapper = styled.div`
  background-image: url(${props => props.styledBg || ''});
  background-size: cover;
  background-repeat: no-repeat;
  background-color: ${p => (p.layout === 'alt' ? 'var(--nude-200)' : '#fff')};
  max-width: 1024px;
  margin: 100px auto;
  padding: 160px 40px;
  text-align: ${p => p.align || 'left'};
  width: calc(100% - 40px);

  iframe {
    max-width: 100%;
  }

  @media (max-width: 800px) {
    padding: 100px 10px;
    margin: 0 16px;
    width: calc(100% - 20px);
  }
`;

const Inner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-direction: column;
  max-width: ${props => (props.fullWidth ? '100%' : '1260px')};
  margin: 0 auto;
  width: ${props => (props.fullWidth ? '100%' : '97%')};
  flex-direction: ${p => (p.layout === 'alt' ? 'row-reverse' : 'row')};

  @media (max-width: 800px) {
    align-items: center;
    flex-direction: column;
  }
`;

const Content = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  justify-content: center;

  @media (max-width: 800px) {
    margin-top: 40px;
  }
`;

const Body = styled.p`
  margin: 0;
  font-weight: normal;
  font-size: 1.2em;
  line-height: 1.4;
  margin-bottom: 2em;
  max-width: 400px;
`;

const Graphic = styled.div`
  margin: 0 8%;
  min-width: 300px;

  > *:not(iframe) {
    box-shadow: ${p => (p.shadow ? `10px 10px 0 var(--nude-300)` : 'none')};
  }

  > img {
    width: 100%;
    display: block;
    margin: 0;
  }
  @media (max-width: 800px) {
    margin: 24px 12px;
  }
`;

export const MarketingSection = ({
  body,
  children,
  cta = null,
  layout,
  shadow = true,
  styledBg = '',
  title,
}) => {
  return (
    <Wrapper layout={layout} styledBg={styledBg}>
      <Inner layout={layout}>
        {children && <Graphic shadow={shadow}>{children}</Graphic>}
        <Content>
          <H1>{title}</H1>
          <Body>{body}</Body>
          {!!cta && cta}
        </Content>
      </Inner>
    </Wrapper>
  );
};

MarketingSection.propTypes = {
  layout: PropTypes.oneOf(['default', 'alt']),
  title: PropTypes.string,
  body: PropTypes.string,
};
